/**
 * 同じ素材を二度上げていないか判定するための指紋。
 *
 * **ファイル全体は読まない。** 数百MBの動画を丸ごとメモリに載せると、
 * 端末によっては落ちる。代わりに「サイズ + 先頭1MB + 末尾1MB」から作る。
 * 別の素材がこの3つとも一致することは現実には起きない。
 *
 * 見つけられるのは**同一のファイル**だけ。撮り直しや、書き出し形式が違うものは
 * 別物として扱われる(→ docs/architecture/data-model.md)。
 */

const EDGE_BYTES = 1024 * 1024;

function toHex(buffer: ArrayBuffer): string {
  return [...new Uint8Array(buffer)].map((byte) => byte.toString(16).padStart(2, "0")).join("");
}

export async function fingerprintOf(file: File): Promise<string> {
  const head = await file.slice(0, EDGE_BYTES).arrayBuffer();
  const tail = await file.slice(Math.max(0, file.size - EDGE_BYTES)).arrayBuffer();
  const size = new TextEncoder().encode(`${String(file.size)}:`);

  const material = new Uint8Array(size.byteLength + head.byteLength + tail.byteLength);
  material.set(size, 0);
  material.set(new Uint8Array(head), size.byteLength);
  material.set(new Uint8Array(tail), size.byteLength + head.byteLength);

  return toHex(await crypto.subtle.digest("SHA-256", material));
}
